import { Route } from "@angular/router";
import { SolicitarTransferenciaDetalhePage } from "./solicitar-transferencia-detalhe.page";

export const SolicitarTransferenciaDetalheRouter: Route[] = [
  { path: 'solicitar-transferencia-detalhe', component: SolicitarTransferenciaDetalhePage }
];
